import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';
import bannerTemplateList from './_banner_template_list';


/**
 * バナーテンプレート画像選択用コンポーネント
 */
export default {
    name: 'bannerTemplateSelecter',
    template: '#banner_template_selecter_template',
    data() {
        return {
        };
    },
    mixins: [commonMixin, modalMixin, flashMessageMixin],
    components: {
        // バナーテンプレートリスト
        'banner-template-list': bannerTemplateList,
        // 確認モーダル
        'modal-open-canva': {
            template: '#modal_open_canva_template',
            data() {
                return {
                    // canvaの共有URL
                    url: null
                };
            },
            mixins: [modalMixin, commonMixin],
            methods: {
                // 確認モーダルを開く
                show: function(url) {
                    this.url = url;
                    this.open();
                }
            }
        }
    },
    emits: ['banner-template-select', 'close'],
    methods: {
        // モーダルを開く
        openModal: async function() {
            this.clearFlashMessage(null, this.$root);
            this.$refs.bannerTemplateList.getTemplateList();
            this.open();
        },
        closeModal: async function() {
            this.close();
            // 視覚効果が終了してからモーダルのHTMLを消す
            await this.$_sleep(500);
            this.$emit('close', this);
        },
        // バナーテンプレート画像が選択されたことを通知する
        emitSelectectBannerImage: function(url) {
            this.$emit('banner-template-select', url);
            this.close();
        }
    }
};
